import { RestResponse } from '../../api/Rest';
import {
  getUrlToGetAttachmentAudio,
  getUrlToGetAttachmentImage,
  getUrlToGetAttachmentVideo,
  getUrlToGetAudio,
  getUrlToGetIcon,
  getUrlToGetImage,
  getUrlToGetResourceImage,
  getUrlToGetStroke,
  getUrlToGetTtsAudio,
  getUrlToGetVideo,
} from '../../api/Rest/files';
import { toPlatformFileVersion } from '../../utils/file';
import { FileType } from '../Base';

import { File, GetFileParams, GetUrlToGetFileData } from './file';
import { ConcreteFileDownload } from './FileDownload';

export const getUrlToGetFile = <F extends File>(
  params: GetFileParams<F>,
  signal: AbortSignal,
): Promise<RestResponse<GetUrlToGetFileData<F>>> => {
  const version = toPlatformFileVersion(params.version);
  if ('attachmentType' in params) {
    // skipped public url
    const attachment = new ConcreteFileDownload(params);
    const v = attachment.getVersion(version);
    if (v?.isUrlDownloaded) {
      return Promise.resolve({
        ok: true,
        data: { url: v.url },
      }) as Promise<RestResponse<GetUrlToGetFileData<F>>>;
    }

    const getUrl = {
      [FileType.Image]: getUrlToGetAttachmentImage,
      [FileType.Audio]: getUrlToGetAttachmentAudio,
      [FileType.Video]: getUrlToGetAttachmentVideo,
    };
    return getUrl[params.attachmentType](
      {
        contextType: params.contextType,
        contextId: params.contextId,
        key: params.key,
      },
      { version, hash: params.hash },
      { signal },
    ) as Promise<RestResponse<GetUrlToGetFileData<F>>>;
  } else {
    const getUrl = {
      [FileType.Image]: getUrlToGetImage,
      [FileType.Icon]: getUrlToGetIcon,
      [FileType.Audio]: getUrlToGetAudio,
      [FileType.Video]: getUrlToGetVideo,
      [FileType.ResourceImage]: getUrlToGetResourceImage,
      [FileType.Stroke]: getUrlToGetStroke,
      [FileType.TtsAudio]: getUrlToGetTtsAudio,
    };
    return getUrl[params.fileType](
      { fileId: params.fileId },
      { version, hash: params.hash, scope: params.scope },
      { signal },
    ) as Promise<RestResponse<GetUrlToGetFileData<F>>>;
  }
};
